import * as React from 'react';
import { createSvgIcon } from '@mui/x-charts/internals';

export const ChartsZoomInIcon = createSvgIcon(
  <React.Fragment>
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14" />
    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2z" />
  </React.Fragment>,
  'ZoomIn',
);

export const ChartsZoomOutIcon = createSvgIcon(
  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14M7 9h5v1H7z" />,
  'ZoomOut',
);

export const ChartsExportIcon = createSvgIcon(
  <path d="M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z" />,
  'Export',
);
